import React from 'react'
import Overlay from '@SiteComponents/Overlay'
import CloseIcon from '@Images/close_dark.svg'

import './Popup.scss'

interface PopupProps {
  readonly zIndex?: number
  readonly className?: string
  readonly children?: React.ReactNode
  readonly shouldNotRenderOverlay?: boolean
  readonly shouldNotRenderContent?: boolean
  closePopup?(): void
}

const DEFAULT_Z_INDEX = 100000

const Popup: React.FC<PopupProps> = props => {
  const {
    zIndex,
    className,
    children,
    shouldNotRenderOverlay,
    shouldNotRenderContent,
  } = props

  const renderCloseIcon = () => {
    return (
      <CloseIcon
        className="Popup__close"
        onClick={props.closePopup}
      />
    )
  }

  return (
    <React.Fragment>
      {!shouldNotRenderOverlay && (
        <Overlay
          zIndex={zIndex}
        />
      )}
      {!shouldNotRenderContent && (
        <div className={`Popup ${className}`} style={{ zIndex: zIndex ?? DEFAULT_Z_INDEX }}>
          {props.closePopup && renderCloseIcon()}
          {children}
        </div>
      )}
    </React.Fragment>
  )
}

export default Popup
